module.exports = __webpack_public_path__ + "static/media/q_type_1.02fa4436.png";